import { cn } from '@helpers/cn';
import { useMemo } from 'react';
import { translateError } from './helpers/translateError';
import { TProps } from './types/TProps';

export const ErrorMessage = ({ error, testid, className = 'error-message' }: TProps) => {
  const message = useMemo(() => translateError(error), [error]);
  return (
    <p
      className={cn('text-center text-[var(--color-danger)]', className)}
      data-testid={testid}
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
};
